import styled from 'styled-components';

export const ItensQuantity = styled.span`
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const BottomBarInnerContainer = styled.div`
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > * > button {
    width: 270px;
    height: 48px;
  }
`;

export const BottombarButtonsContainer = styled.div`
  display: flex;
  gap: 1.5rem;
`;
